import { render, staticRenderFns } from "./template.html?vue&type=template&id=35810946&scoped=true&"
import script from "./HomeHistory.vue?vue&type=script&lang=ts&"
export * from "./HomeHistory.vue?vue&type=script&lang=ts&"
import style0 from "./HomeHistory.vue?vue&type=style&index=0&id=35810946&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35810946",
  null
  
)

export default component.exports